export default {
  // PVThang
  CorrectingExercise: {
    CorrectingExercise: 'Chữa bài tập',
    Title: 'Bài làm của - {StudentName}',
    Correcting: 'Chữa bài',
    WriteComment: 'Viết nhận xét',
    Comment: 'Nhận xét bài làm của {StudentName}',
    CorrectSuccess: 'Bạn đã chữa bài cho học sinh {StudentName}',
    DraftSuccess: 'Bạn đã lưu nháp cho học sinh {StudentName}',
    FlagNotMark: 'Đánh dấu <b>Chưa chữa</b>',
    FlagMarked: 'Đánh dấu <b>Đã chữa</b>',
    DeleteCorrect: 'Xóa bài chữa',
    DeleteCorrectSuccess: 'Xóa bài chữa thành công',
    CorrectAnswer: 'Đáp án đúng: '
  }
}
